// data/weeklyGoal.js
export const weeklyGoalData = {
  current: 1200000,
  benchmark: 1000000,
  goal: 1000000
};
